import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useHistory } from "react-router-dom"
import { TextAnnotate, TextAnnotateBlend } from "react-text-annotate-blend"
import { Box } from "@material-ui/core"
import { ANNO_BG_COLOR } from "../../../utils"
import { addAnnotation } from "../../../actions/viewerActions"

function Annotations(props) {
	const { content, others } = props
	const dispatch = useDispatch()
	const location = useLocation()

	const annotationData = useSelector((state) => state.viewerData.annotations)
	const currentPageNumber = useSelector((state) => state.viewerData.currentPageNumber)
	const { user } = useSelector((state) => state?.authtentication)
	const [value, setValue] = useState([])

	const handleChange = (values) => {
		if (value?.length > values?.length) return false
		setValue(values)
		const payload = {
			fileID: location?.pathname?.split("/")?.[3]?.split("?")[0],
			pageNumber: currentPageNumber,
			start: values[values?.length - 1]?.start,
			end: values[values?.length - 1]?.end,
			text: values[values?.length - 1]?.text,
		}
		dispatch(addAnnotation(payload))
	}

	useEffect(() => {
		if (_.isArray(annotationData)) {
			const annotations = [...annotationData]
			annotations.forEach((i) => (i.color = ANNO_BG_COLOR))
			const annotationPageNumberData = annotations?.filter((i) => i?.page_number === parseInt(currentPageNumber))
			setValue(annotationPageNumberData)
		}
	}, [annotationData])

	return (
		<Box>
			<TextAnnotateBlend
				{...others}
				content={content}
				onChange={handleChange}
				value={value}
				getSpan={(span) => ({
					...span,
					color: ANNO_BG_COLOR,
					pageID: currentPageNumber,
					userID: user?.user?.userid,
					fileID: location?.pathname?.split("/")?.[3]?.split("?")[0],
				})}
			/>
		</Box>
	)
}

export default React.memo(Annotations)
